module.exports = __webpack_public_path__ + "img/hz-wsyh.52ae21c8.jpg";